export const FEATURES = {
  SINGLE_DOC_ABSTRACT: "SINGLE_DOC_ABSTRACT",
  MULTI_DOC_ABSTRACT: "MULTI_DOC_ABSTRACT",
  REST_SINGLE_DOC_ABSTRACT: "REST_SINGLE_DOC_ABSTRACT",
  REST_MULTI_DOC_ABSTRACT: "REST_MULTI_DOC_ABSTRACT",
};

export const SINGLE_DOC_FEATURES = [
  FEATURES.SINGLE_DOC_ABSTRACT,
  FEATURES.REST_SINGLE_DOC_ABSTRACT,
];

export const MULTI_DOC_FEATURES = [
  FEATURES.MULTI_DOC_ABSTRACT,
  FEATURES.REST_MULTI_DOC_ABSTRACT,
];
